var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntroTwo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 354,
    height: 358,
    viewBox: "0 0 354 358",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_2)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M182.508 0.0786059C91.8857 -2.59874 13.3878 63.1937 1.52786 149.522C-11.4396 243.909 59.9293 328.832 147.744 342.439C256.973 359.358 362.917 261.48 353.404 155.296C346.238 75.2965 274.628 2.80023 182.508 0.0786059Z",
    fill: "#F4F7FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M326.621 165.997C326.621 197.513 316.729 226.751 299.956 250.811C299.89 250.911 299.654 251.006 299.654 251.104C273.336 289.686 228.24 314.686 177.653 314.686C173.515 314.686 169.553 314.493 165.501 313.933C165.484 313.933 165.477 314.178 165.46 314.178C163.466 314.014 161.487 313.933 159.517 313.687C158.817 313.604 158.117 313.577 157.42 313.477C156.805 313.395 156.191 313.34 155.576 313.245C155.04 313.166 154.509 313.1 153.978 313.014C153.855 312.993 153.74 312.979 153.62 312.963C152.321 312.749 151.028 312.526 149.738 312.278H149.717C80.9402 299.134 28.9721 238.635 28.9721 165.988C28.9721 150.629 31.203 135.809 35.5222 121.868C36.197 119.683 37.0389 117.522 37.5994 115.382C39.2797 111.815 40.4055 108.314 41.9506 104.879C42.5725 103.507 43.2608 102.141 43.9172 100.789C47.5326 93.3896 51.7548 86.3032 56.5405 79.6023C56.9731 78.996 57.423 78.3934 57.863 77.792C59.6273 75.393 61.4648 73.0493 63.3757 70.761C66.2314 67.3314 69.235 64.0342 72.3866 60.8695C80.6064 52.6163 89.7616 45.352 99.6661 39.2244C102.737 37.3239 105.881 35.5344 109.1 33.8561C130.319 22.782 153.905 17.0176 177.837 17.0566C213.274 17.0566 245.82 29.4435 271.375 50.1268C290.181 65.3424 305.466 85.0406 315.084 107.599C317.236 112.642 318.689 117.818 320.929 123.12C320.929 123.145 320.673 123.161 320.683 123.185C324.746 136.745 326.621 151.115 326.621 165.997Z",
    fill: "#D8DEE8"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M210.265 216.212C207.07 220.715 197.189 226.496 203.894 237.857C210.542 249.185 203.433 251.308 198.854 250.249C194.26 249.201 179.976 248.616 182.358 255.111C184.74 261.606 188.823 264.05 183.587 266.562C178.351 269.073 176.145 275.588 170.792 284.573C165.474 293.574 152.846 285.789 156.581 294.811C160.317 303.833 163.229 302.964 162.878 309.252C162.796 310.974 163.942 312.752 165.492 314.439C163.497 314.273 161.494 314.07 159.507 313.824C158.807 313.742 158.107 313.652 157.41 313.553C156.795 313.47 156.181 313.384 155.566 313.288C155.03 313.21 154.498 313.128 153.968 313.042C153.845 313.021 153.88 313.002 153.761 312.984C152.484 312.77 151.82 312.539 150.14 312.296C149.02 311.232 149.722 310.082 149.894 308.832C151.562 297.22 135.551 289.241 132.868 281.106C130.23 272.989 132.834 268.15 132.225 261.428C131.615 254.707 133.792 245.81 129.931 240.152C126.073 234.507 110.506 232.62 107.55 221.247C104.565 209.896 111.505 192.895 114.201 190C116.863 187.106 101.311 173.936 93.91 173.52C86.475 173.066 89.4495 158.089 76.8803 160.369C64.2865 162.583 41.6605 155.55 46.3337 147.987C50.1846 141.747 56.6634 128.004 35.5222 121.877C36.1982 119.691 37.0352 117.53 37.5957 115.391C39.276 111.824 40.4018 108.323 41.9469 104.888C42.5688 103.515 43.2571 102.15 43.9135 100.797C47.5329 93.3969 51.7562 86.3079 56.5405 79.6023C56.9731 78.996 57.423 78.3934 57.863 77.792C59.6313 75.393 61.4689 73.0493 63.3757 70.761C66.2314 67.3314 69.235 64.0342 72.3866 60.8695C80.6064 52.6163 89.7616 45.352 99.6661 39.2244C103.854 42.1612 108.639 43.9715 112.764 41.7406C122.89 36.0698 116.214 35.2003 112.068 34.99C110.987 34.9216 109.952 34.5262 109.101 33.8561C116.944 29.7585 125.14 26.3759 133.589 23.7494C132.959 29.4693 125.19 38.6562 130.906 37.5346C137.557 36.2678 140.273 18.2864 145.157 24.261C150.11 30.2601 139.737 38.1237 149.48 33.5671C159.235 29.0561 160.542 18.9874 171.409 23.8859C182.333 28.8458 181.336 34.7183 184.386 34.1365C187.435 33.5548 197.248 40.1627 191.305 45.6035C185.309 51.0554 179.811 44.1117 170.824 42.0161C161.831 39.9463 162.049 47.3044 157.918 48.9893C153.71 50.6139 133.413 40.7998 128.432 49.6694C123.392 58.4688 121.252 64.6094 128.728 64.3819C136.204 64.1544 136.678 62.2383 136.093 67.7639C135.508 73.2896 136.855 77.4329 143.621 72.2331C150.368 67.042 148.855 61.9775 154.131 64.452C159.406 66.9264 160.03 64.6869 165.645 60.6087C171.26 56.5306 178.635 56.1063 180.568 65.2563C182.502 74.4063 179.195 76.4638 169.329 76.9262C159.463 77.3886 158.343 74.2906 155.194 82.5453C152.045 90.8 139.011 101.411 127.55 105.782C116.11 110.16 111.626 116.63 111.89 125.36C112.154 134.089 107.86 143.33 104.987 136.122C102.102 128.893 94.0158 116.721 85.7658 124.857C77.5158 132.992 63.1115 147.42 79.0055 150.055C94.8712 152.739 86.5917 137.866 94.6156 140.839C102.622 143.833 89.5417 150.389 94.8958 152.755C100.257 155.144 102.503 154.026 102.462 161.337C102.422 168.648 104.239 175.74 110.746 172.639C117.253 169.539 125.602 155.226 135.011 163.7C144.431 172.194 143.764 171.088 148.705 168.619C153.646 166.149 156.787 173.556 158.81 176.928C160.833 180.3 168.766 176.858 175.204 186.889C181.642 196.921 184.155 198.716 191.487 195.103C198.818 191.491 201.811 194.176 203.718 199.243C205.624 204.31 210.139 199.359 212.314 206.055C214.49 212.752 213.439 211.705 210.265 216.212Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M235.371 94.6161C230.175 83.4578 255.923 84.711 260.473 85.5682C265.052 86.332 275.791 77.9322 277.155 74.0275C278.557 70.092 280.856 71.9613 289.003 71.8494C297.147 71.7633 289.951 69.9198 280.988 66.9633C272.025 64.0068 279.69 63.719 271.443 57.2033C267.895 54.3501 269.012 51.9261 271.377 50.1232C290.327 65.4481 305.241 85.1793 314.819 107.596C314.57 107.517 314.312 107.472 314.052 107.464C308.348 107.431 307.091 94.8141 304.153 92.3557C301.255 89.896 304.234 99.287 304.944 103.143C305.653 106.998 303.381 103.757 300.538 107.299C297.695 110.841 292.527 110.911 292.057 105.592C291.588 100.273 287.846 95.0736 280.258 92.6484C272.669 90.2232 266.105 92.2155 259.941 94.5952C253.818 96.9331 240.604 105.687 235.371 94.6161Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M300.015 251.104C300.53 247.274 301.367 243.315 299.769 241.868C295.884 238.26 295.034 228.43 296.382 223.449C297.729 218.468 308.197 218.74 301.093 210.447C293.964 202.131 287.546 192.259 290.538 186.614C293.53 180.969 292.628 180.564 287.014 180.598C281.401 180.631 278.938 180.878 273.345 175.881C267.749 170.817 260.051 187.83 238.987 174.185C217.928 160.411 229.921 137.178 237.813 137.12C245.754 136.988 255.031 132.976 248.524 123.286C242.036 113.559 252.174 112.186 257.128 114.396C262.09 116.581 270.894 110.706 279.856 108.062C288.844 105.428 288.449 120.077 293.439 123.009C298.459 125.946 307.863 123.616 312.751 118.924C316.242 115.575 317.004 119.48 320.453 123.186C324.607 137.076 326.711 151.499 326.697 165.997C326.706 197.634 316.838 226.982 300.015 251.104Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M262.342 76.0444C262.342 76.0345 268.909 73.0706 266.531 68.2964C264.174 63.5197 260.435 48.8798 257.704 53.4929C254.956 58.1269 259.007 67.1244 258.123 71.007C257.24 74.8896 257.206 76.9385 262.342 76.0444Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M255.784 71.5764C255.692 70.0367 256.661 63.7866 251.745 63.9822C251.754 63.9723 244.635 66.9449 248.795 71.9946C252.988 77.0283 255.896 73.11 255.784 71.5764Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M326.225 165.736C326.225 197.252 316.531 226.49 299.758 250.551C299.694 250.636 299.658 250.738 299.654 250.845C272.776 289.428 228.043 314.304 177.455 314.304C173.323 314.294 169.197 314.002 165.106 313.43C165.09 313.43 165.081 313.799 165.064 313.799C163.07 313.634 161.091 313.614 159.122 313.371C158.422 313.288 157.721 313.291 157.024 313.191C156.409 313.109 155.795 313.068 155.18 312.975C154.644 312.896 154.113 312.838 153.582 312.752C153.459 312.731 153.344 312.721 153.225 312.705C151.927 312.49 150.632 312.269 149.342 312.021H149.322C85.7203 299.866 36.4981 247.18 29.4465 181.877C44.3609 224.682 81.2413 256.845 126.582 265.809H126.598C127.704 266.369 128.828 266.256 129.948 266.441C130.052 266.454 130.159 266.49 130.262 266.506C130.715 266.58 131.176 266.657 131.639 266.722C132.166 266.805 132.697 266.872 133.236 266.942C133.839 267.028 134.44 267.08 135.046 267.15C136.748 267.36 138.454 267.749 140.176 267.888C140.193 267.888 140.201 268.049 140.213 268.049C143.711 268.049 147.198 268.33 150.771 268.33C172.613 268.33 193.198 262.774 211.207 253.187C229.175 243.602 244.597 229.865 256.194 213.118C256.194 213.032 256.334 212.916 256.387 212.829C270.873 192.051 279.349 166.787 279.349 139.572C279.361 127.049 277.543 114.593 273.953 102.597C273.953 102.577 273.902 102.551 273.902 102.531C272.782 97.9551 270.978 93.481 269.123 89.1261C261.966 72.341 251.326 57.2689 237.908 44.9082C224.49 32.5474 208.601 23.1801 191.292 17.4268C221.335 20.1939 248.795 31.9007 270.988 49.8575C289.793 65.073 304.997 84.7713 314.615 107.33C316.767 112.372 318.139 117.549 320.378 122.852C320.378 122.876 320.204 122.892 320.212 122.918C324.27 136.485 326.225 150.854 326.225 165.736Z",
    fill: "#D8DEE8"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M271.307 99.4371C270.883 99.4375 270.473 99.2862 270.15 99.0103C270.141 99.0029 269.198 98.2011 267.43 96.8741C267.052 96.5897 266.801 96.1664 266.735 95.6974C266.668 95.2284 266.79 94.7521 267.074 94.3732C267.359 93.9944 267.782 93.744 268.25 93.6773C268.719 93.6105 269.195 93.7328 269.574 94.0172C271.441 95.4192 272.424 96.2567 272.466 96.2924C272.744 96.5294 272.943 96.8461 273.035 97.1996C273.127 97.5531 273.109 97.9264 272.983 98.2692C272.856 98.612 272.628 98.9078 272.328 99.1167C272.029 99.3255 271.672 99.4373 271.307 99.4371Z",
    fill: "url(#paint0_linear_5_2)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M262.506 93.0087C262.156 93.0082 261.814 92.9042 261.523 92.7099C259.556 91.4013 257.489 90.1002 255.386 88.8421C255.185 88.7217 255.009 88.5629 254.869 88.3747C254.73 88.1865 254.628 87.9726 254.571 87.7452C254.514 87.5177 254.502 87.2813 254.536 87.0492C254.57 86.8172 254.649 86.5941 254.77 86.3928C254.89 86.1915 255.049 86.0159 255.237 85.8759C255.425 85.736 255.639 85.6345 255.866 85.5772C256.093 85.5199 256.329 85.508 256.561 85.5421C256.793 85.5763 257.016 85.6558 257.217 85.7761C259.368 87.0625 261.481 88.3944 263.498 89.7337C263.817 89.9459 264.06 90.255 264.19 90.6156C264.32 90.9761 264.33 91.3689 264.22 91.7359C264.11 92.103 263.885 92.4248 263.578 92.654C263.271 92.8832 262.898 93.0076 262.515 93.0087H262.506ZM249.92 85.4735C249.624 85.473 249.333 85.3991 249.073 85.2583C246.958 84.117 244.783 83.0028 242.613 81.9488C242.397 81.8497 242.202 81.7083 242.042 81.533C241.881 81.3578 241.756 81.1521 241.676 80.9282C241.596 80.7042 241.561 80.4665 241.574 80.2289C241.586 79.9913 241.646 79.7586 241.75 79.5445C241.854 79.3304 241.999 79.1392 242.178 78.9822C242.357 78.8251 242.565 78.7053 242.79 78.6298C243.016 78.5543 243.254 78.5246 243.491 78.5425C243.728 78.5604 243.96 78.6255 244.171 78.734C246.384 79.8114 248.609 80.9477 250.768 82.1149C251.118 82.304 251.394 82.6042 251.554 82.9682C251.713 83.3321 251.747 83.7389 251.65 84.1243C251.553 84.5097 251.33 84.8516 251.016 85.0959C250.703 85.3403 250.317 85.4732 249.92 85.4735ZM236.725 79.0649C236.481 79.0652 236.24 79.0149 236.016 78.9173C233.804 77.958 231.543 77.0344 229.297 76.1723C228.855 76.0027 228.499 75.6643 228.306 75.2316C228.113 74.799 228.1 74.3074 228.27 73.8651C228.439 73.4228 228.778 73.066 229.21 72.8732C229.642 72.6804 230.134 72.6674 230.576 72.837C232.869 73.7163 235.178 74.6596 237.437 75.6398C237.813 75.8038 238.121 76.0923 238.31 76.4568C238.498 76.8214 238.555 77.2398 238.472 77.6416C238.388 78.0435 238.169 78.4044 237.851 78.6635C237.533 78.9227 237.135 79.0644 236.725 79.0649ZM223.033 73.8135C222.84 73.8134 222.649 73.7822 222.467 73.7212C220.176 72.955 217.846 72.2319 215.537 71.5727C215.082 71.4422 214.697 71.1362 214.467 70.7218C214.238 70.3075 214.182 69.8188 214.312 69.3633C214.443 68.9078 214.749 68.5228 215.163 68.293C215.577 68.0631 216.065 68.0073 216.521 68.1378C218.878 68.8117 221.261 69.5509 223.602 70.333C224.003 70.4682 224.343 70.7416 224.561 71.1044C224.78 71.4672 224.862 71.8958 224.794 72.3138C224.726 72.7319 224.512 73.1121 224.19 73.3868C223.868 73.6614 223.458 73.8127 223.035 73.8135H223.033ZM129.231 72.0388C128.802 72.0388 128.387 71.8842 128.063 71.6034C127.739 71.3226 127.526 70.9344 127.465 70.5097C127.403 70.0851 127.496 69.6524 127.727 69.2909C127.958 68.9294 128.312 68.6633 128.723 68.5412C131.092 67.8352 133.498 67.1785 135.875 66.5882C136.335 66.474 136.821 66.5472 137.226 66.7915C137.632 67.0359 137.924 67.4315 138.038 67.8912C138.152 68.3509 138.079 68.8372 137.835 69.243C137.591 69.6488 137.195 69.9409 136.736 70.0551C134.411 70.6331 132.058 71.2751 129.741 71.965C129.575 72.0133 129.403 72.0373 129.231 72.0364V72.0388ZM208.934 69.7858C208.795 69.7861 208.656 69.77 208.52 69.7378C206.171 69.1795 203.785 68.6703 201.429 68.2251C201.199 68.1815 200.979 68.0929 200.783 67.9644C200.587 67.836 200.418 67.6701 200.286 67.4763C200.154 67.2825 200.061 67.0646 200.014 66.8349C199.966 66.6053 199.963 66.3685 200.007 66.1381C200.051 65.9076 200.139 65.688 200.268 65.4918C200.396 65.2955 200.562 65.1265 200.755 64.9944C200.949 64.8622 201.167 64.7696 201.396 64.7217C201.626 64.6738 201.863 64.6715 202.093 64.7152C204.503 65.1714 206.943 65.6916 209.345 66.2623C209.771 66.3631 210.144 66.6168 210.396 66.9753C210.647 67.3338 210.757 67.772 210.707 68.2068C210.656 68.6416 210.448 69.0426 210.121 69.3337C209.794 69.6248 209.372 69.7857 208.934 69.7858ZM143.459 68.5018C143.017 68.5 142.591 68.3342 142.264 68.0365C141.937 67.7387 141.732 67.3301 141.689 66.8898C141.646 66.4495 141.767 66.0088 142.03 65.653C142.293 65.2972 142.678 65.0515 143.111 64.9636C145.533 64.4815 147.99 64.051 150.419 63.6858C150.881 63.6278 151.348 63.753 151.72 64.0348C152.091 64.3165 152.338 64.7325 152.407 65.1937C152.476 65.655 152.362 66.1251 152.09 66.5035C151.817 66.8819 151.408 67.1388 150.948 67.2191C148.577 67.5757 146.174 67.9951 143.809 68.4674C143.694 68.4903 143.577 68.5018 143.459 68.5018ZM194.529 67.0568C194.444 67.0571 194.36 67.0513 194.277 67.0395C191.89 66.7026 189.467 66.4246 187.079 66.1971C186.608 66.1534 186.173 65.9241 185.87 65.5597C185.568 65.1953 185.423 64.7256 185.466 64.254C185.51 63.7823 185.739 63.3473 186.103 63.0448C186.468 62.7422 186.937 62.5967 187.408 62.6404C189.854 62.8679 192.332 63.1582 194.776 63.5013C195.223 63.5639 195.63 63.794 195.915 64.1451C196.199 64.4962 196.34 64.9422 196.309 65.3931C196.278 65.844 196.077 66.2664 195.747 66.5749C195.417 66.8834 194.982 67.0552 194.53 67.0555L194.529 67.0568ZM157.957 66.3189C157.496 66.3232 157.051 66.149 156.715 65.8326C156.38 65.5161 156.179 65.0821 156.156 64.6212C156.133 64.1604 156.289 63.7085 156.592 63.3601C156.894 63.0118 157.319 62.794 157.779 62.7523C160.237 62.5064 162.72 62.3121 165.176 62.1829C165.647 62.1599 166.109 62.3249 166.459 62.6416C166.81 62.9584 167.02 63.4012 167.045 63.8731C167.07 64.3449 166.906 64.8073 166.591 65.159C166.276 65.5107 165.834 65.723 165.362 65.7494C162.964 65.8724 160.534 66.0618 158.139 66.3053C158.077 66.3213 158.017 66.325 157.957 66.325V66.3189ZM179.93 65.6966C179.903 65.6966 179.876 65.6646 179.849 65.6634C177.637 65.565 175.407 65.4838 173.212 65.4838H172.605C172.371 65.49 172.138 65.4493 171.921 65.3641C171.703 65.2789 171.505 65.151 171.337 64.9878C171.17 64.8246 171.036 64.6295 170.946 64.414C170.855 64.1985 170.808 63.967 170.808 63.7331C170.808 63.4992 170.855 63.2677 170.946 63.0522C171.036 62.8367 171.17 62.6417 171.337 62.4785C171.505 62.3153 171.703 62.1873 171.921 62.1022C172.138 62.017 172.371 61.9763 172.605 61.9825L173.204 62.0206H173.218C175.472 62.0206 177.766 62.0489 180.02 62.1436C180.481 62.1675 180.914 62.37 181.227 62.7081C181.541 63.0462 181.711 63.4933 181.701 63.9546C181.691 64.4159 181.502 64.8551 181.173 65.1791C180.845 65.5032 180.404 65.6866 179.943 65.6904L179.93 65.6966Z",
    fill: "url(#paint1_linear_5_2)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M118.894 75.491C118.475 75.4892 118.071 75.3407 117.751 75.0712C117.431 74.8018 117.216 74.4285 117.143 74.0165C117.07 73.6045 117.143 73.1799 117.351 72.8167C117.559 72.4535 117.887 72.1747 118.279 72.029C119.407 71.6108 120.55 71.2001 121.675 70.8102C122.119 70.6688 122.601 70.7066 123.017 70.9154C123.433 71.1242 123.752 71.4876 123.904 71.928C124.057 72.3684 124.031 72.851 123.833 73.2729C123.635 73.6947 123.28 74.0224 122.844 74.1861C121.738 74.5673 120.624 74.9695 119.525 75.379C119.323 75.4539 119.109 75.4919 118.894 75.491Z",
    fill: "url(#paint2_linear_5_2)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M278.392 109.844C278.296 109.844 278.2 109.836 278.106 109.822C278.094 109.822 276.862 109.623 274.664 109.388C274.431 109.363 274.205 109.292 273.999 109.18C273.793 109.068 273.612 108.916 273.464 108.734C273.317 108.551 273.207 108.341 273.141 108.116C273.075 107.891 273.053 107.656 273.078 107.422C273.103 107.189 273.174 106.963 273.286 106.757C273.398 106.551 273.55 106.369 273.732 106.222C273.914 106.075 274.124 105.965 274.349 105.899C274.574 105.832 274.809 105.811 275.042 105.836C277.35 106.082 278.624 106.286 278.677 106.295C279.121 106.365 279.521 106.6 279.799 106.954C280.077 107.307 280.212 107.751 280.176 108.199C280.14 108.647 279.937 109.066 279.607 109.37C279.277 109.675 278.845 109.844 278.396 109.844H278.392Z",
    fill: "url(#paint3_linear_5_2)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M133.342 179.047C133.038 179.047 132.739 178.969 132.473 178.821C132.207 178.673 131.984 178.46 131.824 178.201C131.664 177.942 131.572 177.647 131.559 177.343C131.545 177.039 131.609 176.736 131.744 176.464C132.799 174.335 133.914 172.222 135.063 170.185C135.295 169.772 135.681 169.468 136.137 169.34C136.593 169.212 137.081 169.271 137.494 169.503C137.906 169.735 138.21 170.121 138.338 170.577C138.466 171.033 138.407 171.522 138.175 171.935C137.06 173.92 135.974 175.977 134.946 178.051C134.799 178.35 134.57 178.602 134.287 178.778C134.003 178.954 133.676 179.047 133.342 179.047ZM140.208 166.837C139.888 166.837 139.575 166.75 139.3 166.587C139.024 166.424 138.798 166.19 138.644 165.91C138.491 165.629 138.415 165.313 138.425 164.993C138.435 164.673 138.531 164.362 138.702 164.092C139.976 162.089 141.314 160.107 142.681 158.204C142.957 157.819 143.375 157.56 143.842 157.483C144.309 157.406 144.788 157.518 145.172 157.795C145.557 158.071 145.816 158.489 145.892 158.956C145.969 159.423 145.857 159.902 145.581 160.287C144.253 162.132 142.953 164.062 141.716 166.008C141.555 166.262 141.332 166.472 141.069 166.617C140.805 166.761 140.509 166.837 140.208 166.837ZM148.376 155.46C148.039 155.459 147.709 155.364 147.424 155.184C147.139 155.003 146.911 154.746 146.766 154.442C146.621 154.138 146.565 153.798 146.605 153.463C146.645 153.129 146.778 152.812 146.991 152.55C148.481 150.705 150.041 148.895 151.627 147.157C151.946 146.807 152.391 146.599 152.864 146.577C153.337 146.556 153.799 146.723 154.149 147.043C154.499 147.362 154.707 147.808 154.729 148.281C154.75 148.754 154.583 149.217 154.263 149.566C152.724 151.252 151.21 153.01 149.765 154.798C149.597 155.005 149.386 155.172 149.145 155.286C148.905 155.401 148.642 155.46 148.376 155.46ZM157.822 145.121C157.465 145.122 157.116 145.016 156.82 144.817C156.524 144.618 156.295 144.335 156.161 144.004C156.027 143.673 155.995 143.31 156.069 142.961C156.144 142.612 156.321 142.293 156.578 142.046C158.27 140.403 160.038 138.788 161.83 137.25C162.006 137.087 162.213 136.962 162.439 136.881C162.664 136.801 162.903 136.766 163.143 136.78C163.382 136.794 163.615 136.856 163.83 136.962C164.045 137.068 164.236 137.216 164.392 137.398C164.548 137.58 164.666 137.791 164.739 138.019C164.812 138.247 164.839 138.488 164.817 138.727C164.795 138.965 164.725 139.197 164.611 139.408C164.498 139.619 164.343 139.805 164.157 139.955C162.419 141.449 160.705 143.015 159.064 144.609C158.733 144.936 158.287 145.119 157.822 145.121ZM168.441 135.988C168.068 135.988 167.704 135.87 167.4 135.652C167.096 135.434 166.869 135.126 166.75 134.772C166.63 134.418 166.625 134.035 166.734 133.677C166.844 133.32 167.063 133.006 167.36 132.779C169.233 131.355 171.18 129.964 173.148 128.643C173.541 128.379 174.023 128.283 174.488 128.375C174.952 128.466 175.361 128.739 175.625 129.133C175.888 129.526 175.985 130.008 175.893 130.473C175.801 130.938 175.529 131.347 175.135 131.611C173.227 132.891 171.337 134.241 169.521 135.624C169.211 135.859 168.832 135.987 168.443 135.987L168.441 135.988ZM180.074 128.181C179.684 128.179 179.305 128.049 178.996 127.812C178.686 127.574 178.463 127.242 178.36 126.866C178.257 126.489 178.28 126.089 178.425 125.727C178.571 125.365 178.831 125.061 179.166 124.86C181.186 123.669 183.28 122.512 185.389 121.417C185.597 121.309 185.825 121.244 186.058 121.224C186.292 121.204 186.527 121.231 186.75 121.302C186.974 121.374 187.181 121.488 187.36 121.64C187.539 121.791 187.686 121.976 187.794 122.185C187.901 122.393 187.967 122.621 187.986 122.854C188.006 123.088 187.979 123.323 187.908 123.547C187.837 123.77 187.722 123.978 187.571 124.157C187.419 124.336 187.234 124.483 187.026 124.591C184.977 125.65 182.942 126.774 180.98 127.931C180.706 128.094 180.394 128.179 180.075 128.18L180.074 128.181ZM192.523 121.746C192.114 121.748 191.716 121.609 191.397 121.353C191.078 121.096 190.857 120.738 190.771 120.338C190.684 119.938 190.738 119.52 190.923 119.155C191.107 118.789 191.412 118.498 191.785 118.331C193.92 117.371 196.125 116.448 198.338 115.59C198.78 115.418 199.272 115.428 199.707 115.619C200.141 115.81 200.481 116.166 200.654 116.608C200.826 117.05 200.815 117.543 200.624 117.977C200.433 118.412 200.078 118.753 199.636 118.925C197.48 119.761 195.334 120.659 193.254 121.594C193.024 121.695 192.775 121.747 192.524 121.745L192.523 121.746ZM205.586 116.67C205.162 116.67 204.751 116.519 204.427 116.244C204.104 115.969 203.889 115.588 203.821 115.168C203.754 114.749 203.838 114.319 204.058 113.956C204.279 113.593 204.621 113.321 205.024 113.188C207.244 112.45 209.527 111.755 211.812 111.116C212.038 111.052 212.274 111.034 212.507 111.063C212.74 111.091 212.965 111.165 213.169 111.28C213.374 111.395 213.553 111.549 213.698 111.734C213.843 111.919 213.95 112.13 214.013 112.356C214.076 112.583 214.094 112.819 214.066 113.052C214.038 113.285 213.964 113.51 213.849 113.715C213.734 113.919 213.579 114.099 213.395 114.244C213.21 114.389 212.999 114.496 212.773 114.559C210.542 115.183 208.314 115.863 206.148 116.581C205.967 116.64 205.778 116.669 205.587 116.668L205.586 116.67ZM219.087 112.89C218.649 112.889 218.227 112.727 217.901 112.435C217.575 112.142 217.367 111.74 217.318 111.305C217.268 110.87 217.38 110.431 217.633 110.073C217.885 109.715 218.26 109.463 218.686 109.363C220.965 108.837 223.301 108.352 225.63 107.919C225.86 107.877 226.097 107.88 226.326 107.928C226.555 107.977 226.773 108.071 226.966 108.204C227.159 108.336 227.324 108.506 227.452 108.703C227.58 108.9 227.667 109.12 227.71 109.35C227.753 109.581 227.75 109.818 227.701 110.047C227.652 110.276 227.559 110.494 227.426 110.687C227.293 110.881 227.124 111.046 226.927 111.173C226.73 111.301 226.51 111.389 226.28 111.432C224.002 111.855 221.717 112.329 219.489 112.845C219.357 112.874 219.223 112.889 219.088 112.889L219.087 112.89ZM232.874 110.328C232.423 110.328 231.988 110.156 231.658 109.848C231.327 109.539 231.126 109.117 231.095 108.666C231.064 108.215 231.205 107.769 231.489 107.418C231.774 107.067 232.181 106.837 232.628 106.774C234.944 106.445 237.311 106.159 239.664 105.913C240.135 105.866 240.606 106.007 240.973 106.306C241.34 106.606 241.572 107.039 241.62 107.51C241.668 107.982 241.527 108.453 241.227 108.82C240.928 109.187 240.495 109.42 240.024 109.468C237.718 109.701 235.4 109.984 233.131 110.306C233.047 110.32 232.961 110.327 232.876 110.327L232.874 110.328ZM246.831 108.909C246.371 108.904 245.931 108.721 245.602 108.398C245.274 108.076 245.083 107.639 245.069 107.178C245.054 106.718 245.219 106.27 245.527 105.928C245.835 105.586 246.263 105.376 246.722 105.343C249.067 105.198 251.449 105.097 253.802 105.041C254.26 105.052 254.697 105.24 255.021 105.565C255.346 105.889 255.532 106.326 255.543 106.785C255.554 107.244 255.387 107.69 255.078 108.029C254.769 108.368 254.342 108.576 253.884 108.608C251.578 108.661 249.243 108.76 246.943 108.903L246.831 108.909ZM267.863 108.837C267.83 108.837 267.795 108.837 267.761 108.837C265.496 108.708 263.164 108.623 260.829 108.591C260.372 108.561 259.944 108.356 259.634 108.019C259.323 107.682 259.154 107.239 259.162 106.781C259.169 106.322 259.352 105.885 259.673 105.558C259.993 105.231 260.428 105.04 260.885 105.024C263.268 105.062 265.651 105.147 267.964 105.28C268.422 105.313 268.85 105.522 269.158 105.864C269.467 106.205 269.631 106.652 269.618 107.112C269.605 107.571 269.416 108.008 269.089 108.331C268.762 108.655 268.323 108.839 267.863 108.847V108.837Z",
    fill: "url(#paint4_linear_5_2)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M128.993 188.721C128.701 188.72 128.413 188.648 128.155 188.51C127.897 188.372 127.677 188.173 127.514 187.93C127.35 187.687 127.249 187.408 127.219 187.117C127.189 186.826 127.23 186.532 127.34 186.261C127.794 185.147 128.265 184.026 128.743 182.928C128.836 182.713 128.971 182.519 129.14 182.356C129.309 182.193 129.508 182.065 129.726 181.979C129.944 181.893 130.177 181.851 130.412 181.856C130.646 181.86 130.877 181.91 131.092 182.004C131.307 182.098 131.501 182.233 131.664 182.401C131.827 182.57 131.955 182.77 132.041 182.988C132.126 183.206 132.168 183.439 132.164 183.674C132.16 183.908 132.11 184.14 132.016 184.355C131.55 185.425 131.089 186.519 130.647 187.608C130.513 187.937 130.284 188.218 129.99 188.416C129.695 188.615 129.348 188.721 128.993 188.721Z",
    fill: "url(#paint5_linear_5_2)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M326.194 170.662C326.06 170.661 325.927 170.647 325.796 170.617C325.568 170.565 325.351 170.469 325.16 170.333C324.969 170.197 324.806 170.025 324.682 169.827C324.557 169.628 324.472 169.407 324.433 169.175C324.394 168.944 324.4 168.707 324.453 168.479L324.487 168.321C324.534 168.088 324.627 167.866 324.76 167.669C324.894 167.472 325.065 167.304 325.265 167.174C325.464 167.044 325.688 166.956 325.922 166.913C326.156 166.871 326.396 166.876 326.629 166.928C326.861 166.98 327.08 167.078 327.274 167.216C327.468 167.355 327.632 167.53 327.757 167.733C327.883 167.935 327.966 168.161 328.003 168.396C328.04 168.631 328.029 168.871 327.972 169.102L327.932 169.272C327.843 169.666 327.622 170.019 327.306 170.271C326.991 170.523 326.599 170.661 326.194 170.662ZM327.513 163.472C327.431 163.472 327.349 163.467 327.267 163.455C327.035 163.423 326.812 163.345 326.609 163.227C326.407 163.108 326.23 162.951 326.089 162.764C325.947 162.577 325.844 162.364 325.784 162.137C325.725 161.91 325.711 161.674 325.743 161.442C326.064 159.146 326.263 156.835 326.337 154.518C326.377 154.063 326.588 153.641 326.929 153.337C327.27 153.034 327.714 152.873 328.17 152.887C328.626 152.9 329.059 153.088 329.381 153.411C329.703 153.734 329.889 154.168 329.901 154.625C329.822 157.069 329.613 159.508 329.275 161.93C329.216 162.356 329.005 162.747 328.682 163.03C328.358 163.313 327.943 163.47 327.513 163.472ZM327.866 149.231C327.426 149.23 327.001 149.066 326.674 148.771C326.347 148.476 326.14 148.07 326.094 147.632C325.858 145.368 325.429 143.129 324.81 140.939C324.746 140.714 324.726 140.478 324.753 140.245C324.779 140.012 324.852 139.786 324.965 139.581C325.079 139.376 325.232 139.195 325.415 139.049C325.599 138.903 325.809 138.795 326.035 138.73C326.26 138.666 326.496 138.646 326.729 138.673C326.962 138.699 327.187 138.772 327.392 138.885C327.597 138.999 327.778 139.152 327.923 139.336C328.069 139.519 328.178 139.73 328.242 139.955C328.918 142.343 329.386 144.784 329.643 147.252C329.694 147.723 329.556 148.195 329.258 148.564C328.961 148.933 328.53 149.169 328.059 149.22C327.994 149.227 327.935 149.231 327.866 149.231ZM323.886 135.626C323.561 135.626 323.242 135.538 322.964 135.37C322.686 135.202 322.458 134.962 322.307 134.674C321.258 132.689 319.988 130.83 318.52 129.133C318.21 128.774 318.055 128.307 318.09 127.834C318.125 127.361 318.345 126.921 318.704 126.611C319.063 126.302 319.53 126.147 320.002 126.182C320.475 126.216 320.914 126.437 321.224 126.796C322.868 128.7 324.292 130.784 325.468 133.008C325.612 133.28 325.683 133.585 325.674 133.892C325.666 134.2 325.578 134.501 325.419 134.764C325.261 135.028 325.037 135.246 324.769 135.398C324.501 135.55 324.199 135.63 323.891 135.63L323.886 135.626ZM314.636 124.914C314.254 124.914 313.882 124.791 313.575 124.564C311.749 123.219 309.796 122.055 307.745 121.088C307.317 120.886 306.987 120.521 306.828 120.075C306.669 119.629 306.693 119.138 306.896 118.71C307.098 118.282 307.463 117.952 307.908 117.792C308.354 117.633 308.845 117.657 309.273 117.86C311.534 118.926 313.686 120.21 315.699 121.692C316 121.916 316.224 122.229 316.337 122.588C316.451 122.946 316.448 123.331 316.331 123.688C316.213 124.044 315.986 124.355 315.681 124.575C315.377 124.796 315.011 124.914 314.636 124.914ZM301.816 118.765C301.653 118.765 301.491 118.743 301.334 118.699C297.478 117.62 294.696 117.442 294.668 117.441C294.195 117.413 293.753 117.198 293.439 116.844C293.124 116.49 292.963 116.026 292.99 115.553C293.018 115.08 293.232 114.637 293.586 114.322C293.94 114.008 294.404 113.846 294.877 113.874C295 113.881 298.042 114.068 302.295 115.259C302.711 115.375 303.071 115.637 303.308 115.998C303.545 116.359 303.644 116.793 303.585 117.221C303.527 117.649 303.315 118.042 302.99 118.325C302.665 118.609 302.247 118.766 301.816 118.765Z",
    fill: "url(#paint6_linear_5_2)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M303.783 105.462C303.783 118.621 293.187 129.996 280.075 130.873C266.923 131.752 256.219 121.735 256.219 108.49C256.219 95.2446 266.913 83.8686 280.075 83.0704C293.187 82.276 303.783 92.304 303.783 105.462Z",
    fill: "url(#paint7_linear_5_2)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M305.775 105.462C305.775 118.621 295.178 129.996 282.066 130.873C268.914 131.752 258.211 121.735 258.211 108.49C258.211 95.2446 268.904 83.8686 282.066 83.0704C295.178 82.276 305.775 92.304 305.775 105.462Z",
    fill: "url(#paint8_linear_5_2)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M281.228 119.909C280.731 119.947 280.233 119.849 279.788 119.625C279.343 119.402 278.968 119.06 278.703 118.638L269.738 104.235C268.897 102.882 269.35 101.037 270.748 100.105C272.145 99.1727 273.958 99.5146 274.797 100.864L281.015 110.863L289.217 94.1426C289.954 92.6422 291.722 91.9548 293.167 92.6053C294.613 93.2559 295.187 94.9986 294.451 96.4978L283.849 118.118C283.613 118.604 283.259 119.021 282.818 119.332C282.378 119.643 281.866 119.838 281.33 119.898L281.228 119.909Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M159.187 181.977C159.187 195.137 148.591 206.511 135.48 207.388C122.328 208.269 111.623 198.251 111.623 185.005C111.623 171.76 122.323 160.384 135.48 159.586C148.591 158.796 159.187 168.819 159.187 181.977Z",
    fill: "url(#paint9_linear_5_2)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M161.18 181.977C161.18 195.137 150.582 206.511 137.471 207.388C124.319 208.269 113.616 198.251 113.616 185.005C113.616 171.76 124.309 160.384 137.471 159.586C150.582 158.796 161.18 168.819 161.18 181.977Z",
    fill: "url(#paint10_linear_5_2)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M136.633 196.422C136.136 196.46 135.638 196.362 135.193 196.139C134.748 195.915 134.373 195.573 134.108 195.151L125.144 180.748C124.303 179.395 124.755 177.55 126.154 176.618C127.553 175.686 129.363 176.029 130.203 177.378L136.42 187.376L144.624 170.658C145.362 169.159 147.129 168.47 148.574 169.121C150.018 169.771 150.593 171.514 149.858 173.013L139.262 194.635C139.026 195.12 138.671 195.537 138.23 195.848C137.79 196.159 137.278 196.354 136.742 196.413L136.633 196.422Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M133.362 72.1913C133.362 85.3506 122.765 96.7253 109.653 97.6022C96.5011 98.4827 85.7977 88.4645 85.7977 75.2192C85.7977 61.9739 96.4913 50.5979 109.653 49.7997C122.765 49.0052 133.362 59.0321 133.362 72.1913Z",
    fill: "url(#paint11_linear_5_2)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M135.353 72.1913C135.353 85.3506 124.757 96.7253 111.645 97.6022C98.4935 98.4827 87.7889 88.4645 87.7889 75.2192C87.7889 61.9739 98.4825 50.5979 111.645 49.7997C124.758 49.0052 135.353 59.0321 135.353 72.1913Z",
    fill: "url(#paint12_linear_5_2)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M110.807 86.6308C110.311 86.6686 109.815 86.5703 109.371 86.3464C108.926 86.1225 108.552 85.7816 108.287 85.3604L99.3146 70.9615C98.4751 69.6087 98.9274 67.7639 100.326 66.8329C101.725 65.9019 103.535 66.2426 104.375 67.5917L110.592 77.5903L118.796 60.8732C119.534 59.3728 121.301 58.684 122.746 59.3346C124.19 59.9852 124.765 61.7279 124.03 63.2271L113.431 84.8439C113.195 85.3291 112.84 85.7466 112.399 86.0575C111.959 86.3684 111.446 86.5627 110.91 86.6222L110.807 86.6308Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M234.804 309.335C241.225 303.293 249.695 293.482 253.517 279.618C258.529 261.436 251.142 252.26 251.938 221.487C252.442 202.03 252.989 188.455 262.784 181.184C270.46 175.485 282.897 174.34 290.451 179.605C296.732 183.982 300.374 193.304 301.49 199.959C302.399 205.384 301.678 209.324 304.809 212.178C308.004 215.094 311.446 213.438 314.441 215.597C320.503 219.977 317.014 234.514 316.45 236.862C310.174 262.995 286.135 280.645 275.557 288.214C266.81 294.475 253.277 302.82 234.804 309.335Z",
    fill: "url(#paint13_linear_5_2)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M227.524 314.325L227.215 313.517C262.699 299.979 273.78 282.218 276.827 269.7C278.858 261.363 278.123 252.713 277.106 240.74C276.294 231.177 274.857 224.473 273.588 218.558C271.927 210.81 270.614 204.685 271.514 195.791C272.426 186.766 275.388 177.795 280.317 169.126L281.069 169.554C276.2 178.118 273.275 186.974 272.374 195.872C271.488 204.632 272.788 210.695 274.434 218.378C275.707 224.318 277.152 231.045 277.968 240.666C278.951 252.269 279.732 261.432 277.668 269.907C275.028 280.75 267.81 290.593 256.216 299.163C248.393 304.945 238.74 310.041 227.524 314.325Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M277.041 234.195L276.594 234.001C276.53 233.972 270.13 231.145 263.737 224.578C257.837 218.516 250.721 207.934 250.324 191.939L251.185 191.918C251.576 207.632 258.56 218.024 264.353 223.974C269.666 229.432 274.956 232.247 276.492 232.998C281.719 215.74 290.978 204.899 297.858 198.829C305.391 192.179 311.797 189.644 311.861 189.62L312.175 190.426C312.112 190.451 305.821 192.945 298.399 199.505C291.552 205.556 282.313 216.404 277.176 233.726L277.041 234.195Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M278.335 260.082L278.157 259.822C278.096 259.731 271.799 250.576 263.693 242.638C255.655 234.767 236.816 232.044 236.627 232.017L236.75 231.156C240.338 231.718 243.888 232.505 247.377 233.515C255.141 235.761 260.836 238.621 264.301 242.016C271.699 249.26 277.599 257.511 278.693 259.068C298.401 252.855 319.394 206.659 319.604 206.192L320.393 206.547C320.339 206.67 314.974 218.528 307.205 230.965C296.738 247.722 287.127 257.487 278.64 259.99L278.335 260.082Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M258.905 296.882L259.334 296.134C264.358 287.379 263.61 278.19 257.113 268.82C252.241 261.792 245.805 257.313 245.735 257.269L246.226 256.556C246.292 256.601 252.864 261.17 257.825 268.325C264.246 277.586 265.166 287.067 260.51 295.799C266.239 294.924 299.526 288.951 321.862 265.514L346.646 239.509L347.272 240.107L322.489 266.112C297.882 291.931 260.14 296.735 259.762 296.779L258.905 296.882Z",
    fill: "white"
  })))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M207.4 323.552C224.678 330.439 247.672 336.745 272.561 335.437C278.913 335.104 318.151 333.042 320.143 316.306C320.845 310.41 316.333 307.674 317.134 299.775C318.083 290.417 325.025 288.27 332.805 279.182C337.446 273.76 351.028 257.893 343.997 243.421C339.796 234.773 328.424 227.015 318.046 225.521C302.825 223.328 292.726 235.041 275.981 255.154C261.138 272.986 260.932 278.703 250.02 291.354C241.921 300.744 228.823 312.912 207.4 323.552Z",
    fill: "url(#paint14_linear_5_2)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M199.869 323.652C195.173 323.651 190.482 323.332 185.829 322.695C166.619 320.073 148.205 312.383 131.099 299.837L131.611 299.14C148.598 311.598 166.879 319.234 185.946 321.837C211.343 325.304 236.908 319.254 261.929 303.868C287.986 287.837 306.935 265.685 318.238 249.925C326.059 239.02 330.698 225.372 332.024 209.362L332.885 209.433C331.544 225.602 326.852 239.396 318.939 250.43C307.59 266.254 288.565 288.5 262.38 304.605C241.789 317.272 220.821 323.652 199.869 323.652Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M292.875 280.316L292.752 279.947C292.726 279.867 290.228 271.899 289.911 261.104C289.625 251.132 291.183 236.62 300.279 224.139L300.979 224.649C284.855 246.769 292.431 275.699 293.468 279.31C339.473 269.752 349.763 242.309 351.823 234.108C351.854 233.968 351.892 233.831 351.937 233.696L352.744 234.011C352.728 234.057 352.702 234.162 352.663 234.319C350.566 242.669 340.084 270.653 293.255 280.239L292.875 280.316Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M302.833 316.332C292.611 316.332 278.828 313.731 262.376 304.344L262.176 304.229L262.159 303.998C262.141 303.752 260.543 278.599 274.006 250.522L287.575 222.223L288.355 222.592L274.786 250.891C262.111 277.333 262.882 301.125 263.009 303.703C274.702 310.344 292.436 317.615 310.915 314.882C322.024 313.239 328.213 308.684 328.274 308.637L328.793 309.331C328.537 309.522 322.401 314.046 311.093 315.726C308.359 316.131 305.598 316.334 302.833 316.332Z",
    fill: "white"
  })))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M118.624 309.335C112.203 303.293 103.735 293.482 99.9119 279.618C94.9007 261.436 102.287 252.26 101.49 221.487C100.987 202.03 100.439 188.455 90.6442 181.184C82.9682 175.485 70.5318 174.34 62.9775 179.605C56.6966 183.982 53.0546 193.304 51.9386 199.959C51.0302 205.384 51.7505 209.324 48.6199 212.178C45.4241 215.094 41.9764 213.438 38.9871 215.597C32.925 219.977 36.4158 234.514 36.9799 236.862C43.2547 262.995 67.293 280.645 77.871 288.214C86.6188 294.475 100.152 302.82 118.624 309.335Z",
    fill: "url(#paint15_linear_5_2)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M125.906 314.325C114.689 310.046 105.036 304.945 97.2128 299.162C85.6183 290.592 78.4069 280.749 75.7606 269.906C73.6968 261.431 74.4749 252.267 75.4606 240.666C76.2768 231.049 77.721 224.317 78.9944 218.377C80.6402 210.7 81.9444 204.637 81.0545 195.871C80.1535 186.968 77.2282 178.112 72.3595 169.552L73.1118 169.124C78.0406 177.794 81.0028 186.765 81.9149 195.79C82.8158 204.684 81.5019 210.806 79.8401 218.556C78.5716 224.472 77.136 231.176 76.3223 240.736C75.3058 252.711 74.5708 261.362 76.6013 269.699C79.6483 282.216 90.729 299.978 126.213 313.516L125.906 314.325Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3874 234.195L76.2485 233.726C71.112 216.404 61.8676 205.556 55.0262 199.505C47.6034 192.945 41.3127 190.451 41.25 190.426L41.5634 189.62C41.6273 189.644 48.0336 192.179 55.567 198.829C62.4502 204.899 71.7056 215.74 76.9332 232.997C78.472 232.243 83.7832 229.416 89.1017 223.948C94.8786 217.999 101.854 207.616 102.244 191.918L103.104 191.939C102.708 207.934 95.5915 218.516 89.6917 224.578C83.3001 231.145 76.8988 233.972 76.8361 234.001L76.3874 234.195Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0931 260.082L74.792 259.993C66.3109 257.491 56.6941 247.726 46.228 230.969C38.4586 218.532 33.0934 206.669 33.0393 206.551L33.8284 206.195C34.0398 206.663 55.0336 252.86 74.7391 259.078C75.8331 257.518 81.733 249.27 89.1312 242.025C92.5973 238.631 98.2907 235.77 106.055 233.525C109.544 232.516 113.094 231.728 116.682 231.166L116.805 232.027C116.616 232.054 97.7745 234.777 89.7396 242.648C81.6273 250.586 75.3377 259.742 75.2751 259.832L75.0931 260.082Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M94.521 296.882L93.6606 296.779C93.282 296.733 55.54 291.931 30.9338 266.112L6.15799 240.102L6.78485 239.504L31.568 265.509C53.904 288.946 87.1904 294.914 92.9231 295.794C88.2658 287.062 89.1865 277.581 95.6075 268.32C100.568 261.165 107.141 256.596 107.206 256.551L107.697 257.264C107.633 257.309 101.176 261.802 96.3069 268.833C89.8219 278.197 89.0795 287.38 94.0944 296.136L94.521 296.882Z",
    fill: "white"
  })))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M146.028 323.552C128.75 330.439 105.757 336.745 80.8676 335.437C74.5167 335.104 35.2764 333.039 33.2851 316.306C32.5833 310.41 37.0955 307.674 36.2941 299.775C35.3452 290.417 28.403 288.27 20.625 279.182C15.9788 273.761 2.40052 257.896 9.4312 243.421C13.6324 234.773 25.0044 227.015 35.3821 225.521C50.6037 223.328 60.7024 235.041 77.447 255.154C92.2901 272.986 92.4966 278.703 103.409 291.354C111.508 300.744 124.605 312.912 146.028 323.552Z",
    fill: "url(#paint16_linear_5_2)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M153.559 323.652C132.606 323.652 111.645 317.273 91.0462 304.605C64.8654 288.495 45.8359 266.254 34.4872 250.43C26.574 239.396 21.8787 225.602 20.5426 209.433L21.403 209.362C22.7305 225.372 27.3681 239.02 35.1891 249.925C46.4972 265.685 65.4358 287.837 91.4985 303.868C116.523 319.258 142.089 325.304 167.483 321.837C186.549 319.234 204.83 311.598 221.818 299.14L222.329 299.837C205.223 312.382 186.807 320.073 167.6 322.695C162.946 323.332 158.255 323.651 153.559 323.652Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5536 280.316L60.1738 280.239C13.3436 270.653 2.86145 242.669 0.764534 234.319C0.725201 234.162 0.699389 234.057 0.683411 234.011L1.48973 233.696C1.53485 233.831 1.57301 233.968 1.60404 234.108C3.66408 242.309 13.9544 269.752 59.9587 279.31C60.9949 275.698 68.5627 246.76 52.4499 224.649L53.1481 224.139C62.2437 236.617 63.8035 251.127 63.5122 261.103C63.1951 271.898 60.6974 279.866 60.6729 279.946L60.5536 280.316Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5964 316.332C47.8301 316.337 45.0672 316.137 42.3304 315.734C31.0223 314.051 24.8913 309.527 24.6308 309.339L25.1495 308.645C25.2109 308.692 31.4009 313.248 42.5086 314.891C52.7338 316.403 69.3334 315.684 90.4144 303.711C90.5373 301.129 91.3141 277.336 78.638 250.9L65.0744 222.6L65.8537 222.231L79.4222 250.517C92.8862 278.594 91.2871 303.742 91.2699 303.993L91.2527 304.224L91.0523 304.339C74.6089 313.731 60.8179 316.332 50.5964 316.332Z",
    fill: "white"
  })))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M210.552 176.245C207.59 174.575 207.367 170.726 207.279 169.204C207.071 165.61 208.369 159.762 212.188 158.89C215.261 158.19 218.059 161.137 218.406 161.509C221.928 165.313 220.23 170.765 220.042 171.333C219.623 172.607 218.758 175.234 216.109 176.409C215.934 176.492 213.118 177.69 210.552 176.245Z",
    fill: "url(#paint17_linear_5_2)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M216.12 168.714C214.399 166.181 211.31 166.456 210.393 164.294C209.935 163.214 210.044 161.588 211.767 159.014C208.278 160.207 207.083 165.746 207.284 169.204C207.372 170.726 207.595 174.575 210.557 176.245C213.118 177.69 215.934 176.491 216.12 176.409C216.243 176.357 216.347 176.302 216.457 176.245C217.261 173.596 217.528 170.782 216.12 168.714Z",
    fill: "url(#paint18_linear_5_2)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M195.829 248.612C195.829 248.612 189.915 206.208 192.463 191.308C195.011 176.409 208.831 173.407 214.764 173.271C220.697 173.136 232.56 177.287 233.466 194.91C234.371 212.534 225.345 249.627 225.345 249.627L195.829 248.612Z",
    fill: "url(#paint19_linear_5_2)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M212.992 210.984C222.259 211.845 225.732 203.605 234.256 204.435C235.184 204.526 236.1 204.716 236.987 205.004C237.138 203.33 237.249 201.711 237.309 200.173C236.322 199.824 235.297 199.596 234.256 199.494C225.734 198.671 222.262 206.909 212.992 206.043C205.439 205.338 203.012 199.423 196.376 200.313C194.761 200.541 193.212 201.105 191.828 201.97C191.836 203.533 191.873 205.167 191.934 206.845C193.291 206.017 194.803 205.475 196.377 205.253C203.012 204.363 205.439 210.278 212.992 210.984Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    d: "M211.211 226.362C204.293 225.656 202.071 219.741 195.993 220.631C194.892 220.798 193.828 221.152 192.847 221.678C194.033 235.735 195.829 248.611 195.829 248.611L225.345 249.626C225.345 249.626 228.881 235.092 231.305 219.896C231.092 219.86 230.884 219.833 230.69 219.812C222.879 218.989 219.699 227.228 211.211 226.362Z",
    fill: "url(#paint20_linear_5_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M230.684 204.435C222.879 203.611 219.699 211.85 211.211 210.984C204.293 210.278 202.071 204.363 195.993 205.253C194.537 205.481 193.148 206.024 191.924 206.845C192.085 211.592 192.428 216.709 192.847 221.678C193.828 221.152 194.892 220.798 195.993 220.631C202.071 219.741 204.293 225.656 211.211 226.362C219.699 227.223 222.879 218.989 230.684 219.813C230.884 219.834 231.44 204.522 230.684 204.435Z",
    fill: "url(#paint21_linear_5_2)"
  }), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M166.539 279.065C160.134 271.459 165.669 255.426 172.483 246.313C183.865 231.088 202.999 229.578 212.848 228.801C223.419 227.967 237.785 226.833 249.57 236.436C263.438 247.733 269.374 270.342 261.615 279.065C255.314 286.147 244.811 278.655 214.979 278.738C184.79 278.822 172.846 286.551 166.539 279.065Z",
    fill: "url(#paint22_linear_5_2)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M193.852 233.947C199.32 232.241 208.266 232.24 208.171 212.593C208.171 212.593 219.514 212.429 219.944 212.593C220.351 212.747 216.939 232.072 232.803 232.73C233.883 232.775 234.167 234.312 233.295 234.958C230.425 237.095 223.953 240.304 214.376 239.935C208.317 239.701 201.411 240.718 193.815 236.319C192.78 235.716 192.705 234.306 193.852 233.947Z",
    fill: "url(#paint23_linear_5_2)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M223.631 273.858C220.482 273.202 226.089 246.57 223.32 205.061C222.746 196.453 221.956 189.369 221.354 184.596L231.591 185.481C235.5 198.037 240.62 220.944 234.396 247.814C231.472 260.446 225.948 274.342 223.631 273.858Z",
    fill: "url(#paint24_linear_5_2)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M223.631 273.858C220.482 273.202 226.089 246.57 223.32 205.061C222.746 196.453 221.956 189.369 221.354 184.596L231.591 185.481C235.5 198.037 240.62 220.944 234.396 247.814C231.472 260.446 225.948 274.342 223.631 273.858Z",
    fill: "url(#paint25_linear_5_2)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M200.507 196.39C200.507 199.006 199.32 218.158 213.942 218.158C227.309 218.158 226.141 204.162 225.75 197.138C225.75 197.138 225.136 190.827 220.637 189.034C220.637 189.034 224.805 192.64 224.741 200.437C224.741 200.437 223.702 196.278 213.899 196.133C204.095 195.988 202.049 200.437 202.049 200.437C202.049 200.437 200.318 192.935 205.303 189.034C205.303 189.035 201.768 190.132 200.507 196.39Z",
    fill: "url(#paint26_linear_5_2)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M139.694 217.249C126.233 218.641 121.98 223.424 116.647 220.078C111.798 217.031 113.787 212.119 108.611 208.624C101.367 203.732 92.6183 210.075 89.2062 205.927C86.5401 202.687 91.7136 198.61 90.804 190.062C89.7199 179.905 81.5609 177.728 82.7396 169.608C83.5718 163.878 88.3507 160.034 88.6973 159.762C92.3982 156.864 94.2063 158.394 97.6258 155.749C102.585 151.914 100.472 147.386 105.541 142.936C105.936 142.588 110.961 138.291 116.261 139.446C120.365 140.341 120.3 143.561 123.752 144.423C129.935 145.967 133.41 136.445 141.135 136.529C147.241 136.595 147.483 142.571 154.92 144.022C164.082 145.81 170.792 138.119 174.375 141.204C176.673 143.179 174.087 146.492 176.726 150.254C179.618 154.379 184.016 152.244 188.823 156.574C191.65 159.121 194.18 163.509 194 168.002C193.823 172.467 191.108 173.564 191.707 177.525C192.291 181.393 195.06 181.548 195.757 185.249C196.541 189.417 193.986 194.31 190.586 196.958C185.915 200.591 181.721 198.401 179.123 202.035C177.181 204.752 178.897 206.855 177.25 210.058C175.663 213.146 172.134 214.953 165.391 216.35C153.643 218.788 150.839 216.098 139.694 217.249Z",
    fill: "url(#paint27_linear_5_2)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M183.38 194.896C175.6 193.345 174.879 186.122 166.672 183.841C152.593 179.926 140.825 197.315 133.792 193.008C127.075 188.894 136.259 172.078 127.055 161.998C120.276 154.574 109.92 157.804 107.651 152.29C106.623 149.795 107.405 145.865 113.079 139.344C109.097 139.886 105.854 142.665 105.539 142.936C100.47 147.391 102.589 151.914 97.6233 155.749C94.2038 158.394 92.3958 156.864 88.6948 159.762C88.3482 160.033 83.5693 163.878 82.7372 169.608C81.5584 177.725 89.7175 179.905 90.8016 190.062C91.7136 198.606 86.5401 202.683 89.2037 205.927C92.6158 210.075 101.365 203.732 108.608 208.624C113.784 212.119 111.795 217.031 116.644 220.078C121.978 223.428 126.232 218.645 139.692 217.249C150.837 216.098 153.636 218.785 165.381 216.35C172.124 214.953 175.653 213.153 177.24 210.058C178.887 206.861 177.171 204.752 179.113 202.035C181.711 198.401 185.91 200.591 190.576 196.958C191.878 195.925 192.991 194.674 193.866 193.261C190.457 194.855 186.903 195.598 183.38 194.896Z",
    fill: "url(#paint28_linear_5_2)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4643 267.096C94.0392 274.264 115.854 304.085 146.809 303.727C177.997 303.367 186.457 273.245 191.304 266.242C193.553 262.994 192.702 259.218 191.085 252.048C189.979 247.148 187.823 237.578 179.847 231.004C170.062 222.938 156.38 223.387 142.619 223.84C128.22 224.312 108.356 224.965 97.3111 237.422C89.5884 246.133 88.8018 257.66 88.7071 259.362C88.4871 263.379 88.3753 265.387 89.4643 267.096Z",
    fill: "url(#paint29_linear_5_2)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M135.401 201.037C135.401 201.037 137.245 222.348 122.308 226.606C121.935 226.713 121.598 226.922 121.336 227.209C121.073 227.496 120.895 227.85 120.822 228.232C120.748 228.613 120.781 229.008 120.917 229.372C121.053 229.737 121.288 230.056 121.594 230.295C126.316 233.998 134.848 239.919 141.965 240.684C149.371 241.481 158.178 233.828 162.684 229.299C162.955 229.025 163.146 228.681 163.236 228.306C163.326 227.931 163.311 227.539 163.194 227.171C163.077 226.804 162.861 226.475 162.571 226.222C162.28 225.968 161.926 225.799 161.546 225.732C155.155 224.592 143.706 220.024 144.892 201.863L135.401 201.037Z",
    fill: "url(#paint30_linear_5_2)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M125.418 185.705C125.418 185.705 124.358 206.963 139.664 206.716C154.969 206.468 153.886 188.331 153.038 183.646C153.038 183.646 153.145 171.304 142.95 172.363C132.756 173.421 125.876 176.629 125.418 185.705Z",
    fill: "url(#paint31_linear_5_2)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M151.837 191.202C151.837 191.202 153.305 185.647 156.333 188.397C160.735 192.393 151.353 196.927 151.353 196.927L151.837 191.202Z",
    fill: "url(#paint32_linear_5_2)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M126.874 191.202C126.874 191.202 125.407 185.647 122.378 188.397C117.977 192.393 127.359 196.927 127.359 196.927L126.874 191.202Z",
    fill: "url(#paint33_linear_5_2)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M124.948 185.416C124.977 185.509 125.034 185.59 125.111 185.649C125.189 185.708 125.282 185.742 125.38 185.745C125.477 185.748 125.572 185.721 125.653 185.667C125.734 185.613 125.796 185.535 125.831 185.444C126.867 182.72 130.141 176.545 138.726 175.651C146.405 174.851 150.489 180.497 152.268 184.028C152.35 184.198 152.485 184.337 152.654 184.423C152.822 184.509 153.014 184.537 153.199 184.503C153.385 184.469 153.555 184.375 153.682 184.235C153.809 184.095 153.886 183.917 153.902 183.729C154.418 178.61 153.716 168.746 140.627 168.746C124.127 168.746 123.664 181.278 124.948 185.416Z",
    fill: "url(#paint34_linear_5_2)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M190.43 304.377C185.444 296.112 192.481 282.569 196.913 276.43C209.833 258.537 233.571 257.932 253.032 257.436C272.15 256.944 290.605 256.48 304.11 270.203C312.933 279.169 328.334 299.894 320.726 333.761C318.348 344.329 284.885 350.054 247.303 349.927C205.972 349.788 196.655 314.696 190.43 304.377Z",
    fill: "url(#paint35_linear_5_2)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M271.077 260.499C271.077 264.039 262.436 268.288 251.78 268.288C241.123 268.288 232.482 264.039 232.482 260.499C232.482 256.958 241.123 258.54 251.78 258.54C262.436 258.54 271.077 256.957 271.077 260.499Z",
    fill: "url(#paint36_linear_5_2)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M244.681 235.797C241.746 235.797 248.52 256.428 237.852 259.261C237.624 259.32 237.419 259.447 237.263 259.624C237.108 259.802 237.009 260.022 236.981 260.256C236.952 260.491 236.995 260.728 237.104 260.938C237.212 261.147 237.382 261.319 237.589 261.431C240.453 262.984 245.817 264.951 254.615 264.951C258.906 264.965 263.105 263.706 266.682 261.334C266.851 261.219 266.988 261.063 267.078 260.88C267.168 260.696 267.209 260.493 267.197 260.289C267.184 260.085 267.119 259.888 267.007 259.717C266.895 259.546 266.741 259.407 266.559 259.314C263.27 257.618 258.704 252.224 260.067 236.325L244.681 235.797Z",
    fill: "url(#paint37_linear_5_2)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M235.766 211.062C235.809 211.32 236.697 230.153 240.999 239.557C242.228 242.257 248.358 241.933 252.322 241.607C255.763 241.326 261.162 242.582 262.682 240.204C268.792 230.643 267.756 206.96 267.756 206.96C267.756 206.96 264.625 199.081 251.787 199.297C238.949 199.514 235.766 211.062 235.766 211.062Z",
    fill: "url(#paint38_linear_5_2)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M238.771 221.176C238.771 221.176 236.085 218.052 233.554 217.636C231.023 217.221 229.375 223.778 232.826 228.046C236.278 232.313 240.27 228.775 240.27 228.775L238.771 221.176Z",
    fill: "url(#paint39_linear_5_2)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M264.941 221.176C264.941 221.176 267.627 218.052 270.158 217.636C272.689 217.221 274.337 223.778 270.884 228.046C267.432 232.313 263.442 228.775 263.442 228.775L264.941 221.176Z",
    fill: "url(#paint40_linear_5_2)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M236.667 220.941C237.005 221.556 237.393 222.139 237.651 222.071C238.736 221.788 234.55 211.206 238.407 207.5C240.399 205.584 242.645 207.33 250.811 206.96C259.035 206.591 261.136 204.624 263.625 206.126C265.89 207.501 267.917 211.423 266.238 223.043L267.641 222.719C267.011 218.907 267.698 216.512 268.484 214.998C269.057 213.892 270.094 212.471 270.014 210.414C269.964 209.14 269.542 209.082 269.472 208.039C269.268 204.978 272.757 204.155 272.926 201.132C273.056 198.804 271.049 198.275 271.417 195.844C271.727 193.775 273.295 193.384 273.046 191.894C272.78 190.281 270.68 189.081 269.208 188.663C267.704 188.235 267.161 188.71 266.28 188.101C264.857 187.117 265.542 185.374 264.512 184.726C262.68 183.574 259.038 188.178 256.683 187.032C255.257 186.337 255.806 184.266 254.544 183.764C252.107 182.793 247.799 189.627 246.063 188.721C245.233 188.285 246.034 186.621 244.87 185.4C243.503 183.961 240.223 183.964 238.724 185.487C237.33 186.907 238.514 188.603 237.037 190.407C235.712 192.023 234.182 191.357 232.686 192.652C230.146 194.851 231.029 199.828 231.345 201.604C232.432 207.718 235.816 208.955 235.056 213.123C234.862 214.19 234.41 215.376 234.733 217.118C235.059 218.815 235.945 220.102 236.667 220.941Z",
    fill: "url(#paint41_linear_5_2)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M267.917 207.736C267.617 204.731 269.944 203.331 269.553 201.187C269.24 199.466 267.291 197.916 265.462 197.585C261.56 196.879 259.034 202.628 255.154 202.005C252.153 201.523 252.485 197.898 249.099 196.439C243.731 194.127 238.105 201.174 234.536 199.222C233.463 198.636 232.378 197.131 232.301 193.037C230.254 195.39 231.058 199.917 231.355 201.593C232.442 207.707 235.825 208.944 235.066 213.112C234.872 214.179 234.419 215.365 234.743 217.106C235.058 218.815 235.945 220.102 236.667 220.941C237.005 221.556 237.393 222.139 237.651 222.071C238.736 221.788 234.55 211.206 238.407 207.5C240.399 205.584 242.645 207.33 250.812 206.96C259.035 206.591 261.137 204.624 263.625 206.126C265.89 207.501 267.917 211.423 266.238 223.043L267.641 222.719C267.011 218.907 267.698 216.512 268.484 214.998C268.72 214.543 269.034 214.033 269.317 213.448C269.253 212.343 269.057 211.25 268.732 210.192C268.321 208.837 268.014 208.703 267.917 207.736Z",
    fill: "url(#paint42_linear_5_2)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M100.034 351.118C57.3235 351.447 48.6765 341.36 41.8953 332.097C35.6525 323.572 33.0922 292.929 40.5432 284.337C52.3196 270.752 71.2251 270.085 97.0837 269.365C121.405 268.686 136.393 268.269 148.227 278.756C159.289 288.561 166.357 306.796 159.466 316.216C153.074 324.963 140.812 350.808 100.034 351.118Z",
    fill: "url(#paint43_linear_5_2)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8109 269.326L77.812 270.608C77.5271 270.68 77.2634 270.819 77.0427 271.013C76.822 271.207 76.6505 271.451 76.5425 271.725C76.4345 271.998 76.3929 272.294 76.4213 272.586C76.4497 272.879 76.5472 273.161 76.7058 273.408C80.1105 278.719 89.1287 292.055 94.7742 293.624C100.611 295.246 111.516 278.347 115.145 272.4C115.291 272.16 115.381 271.889 115.408 271.609C115.434 271.33 115.397 271.047 115.299 270.784C115.2 270.52 115.043 270.283 114.84 270.089C114.636 269.895 114.391 269.75 114.123 269.665L110.456 268.496C107.455 267.54 104.297 267.179 101.158 267.434L87.4878 268.541C85.9095 268.67 84.3449 268.932 82.8109 269.326Z",
    fill: "#39C8DB"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5229 249.902C86.5229 249.902 89.2713 269.684 85.4708 271.573L96.2872 283.368L107.245 269.397C107.245 269.397 103.103 266.275 104.194 249.902H86.5229Z",
    fill: "url(#paint44_linear_5_2)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M80.14 221.584C79.7492 222.113 74.6728 247.042 92.2422 249.648C109.811 252.254 110.587 233.832 110.363 226.017C110.14 218.201 102.102 215.363 97.5029 214.816C92.9034 214.27 81.5277 219.706 80.14 221.584Z",
    fill: "url(#paint45_linear_5_2)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1223 236.138C79.1223 236.138 78.2422 232.064 75.232 234.605C72.2219 237.145 77.0094 243.887 80.9574 243.608L79.1223 236.138Z",
    fill: "url(#paint46_linear_5_2)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M109.823 233.3C109.317 233.642 107.868 243.205 107.868 243.205C107.868 243.205 110.404 243.504 112.24 240.07C114.077 236.636 114.959 229.824 109.823 233.3Z",
    fill: "url(#paint47_linear_5_2)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M116.729 215.028C114.878 211.953 110.204 213.41 108.838 210.447C107.692 207.958 110.387 205.616 108.941 203.465C107.732 201.666 104.776 201.711 104.25 201.719C100.255 201.779 99.3416 204.943 96.4937 204.872C93.0152 204.785 92.88 200.028 88.2806 198.026C83.8188 196.081 77.297 197.664 74.6605 201.309C72.6115 204.138 74.3557 206.229 71.6688 209.863C69.825 212.367 68.1866 212.477 67.2684 214.926C66.408 217.227 66.9906 219.417 67.4467 221.046C68.5394 224.948 70.5785 226.67 73.6575 230.822C75.5957 233.44 77.3416 236.196 78.8814 239.068C80.0852 242.288 81.1111 245.573 81.9542 248.906C82.9375 252.794 82.8797 253.58 83.7979 254.84C86.9716 259.18 94.2173 258.761 97.2656 258.584C100.761 258.381 105.112 258.129 107.302 255.091C108.485 253.449 108.336 251.965 108.611 247.996C108.886 244.095 109.393 240.214 110.131 236.374C110.487 234.697 110.964 233.049 111.559 231.441C112.833 228.042 114.155 227.506 115.593 223.989C116.748 221.169 118.236 217.53 116.729 215.028ZM102.177 241.559C100.018 242.142 98.5599 241.618 95.6321 241.45C89.7765 241.113 87.9241 243.857 85.1598 242.65C84.0069 242.147 81.3409 240.74 80.7767 238.043C80.3492 235.766 80.2882 233.434 80.596 231.138C81.0532 227.758 81.5793 223.858 84.2834 222.134C88.2167 219.633 93.2254 223.938 96.8207 221.15C98.1973 220.084 98.7516 218.458 99.0024 217.215C99.8026 217.49 106.163 219.805 108.505 226.6C109.948 230.788 109.119 234.525 108.419 236.561C107.111 238.549 105.099 240.77 102.177 241.559Z",
    fill: "url(#paint48_linear_5_2)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0297 245.678C93.1248 246.657 96.4593 246.562 99.4941 245.41C99.8886 245.26 100.232 245.693 99.8972 245.928C98.5353 246.897 96.5466 247.925 94.3845 247.765C92.5974 247.632 90.9552 246.942 89.6904 246.224C89.3328 246.019 89.6192 245.55 90.0297 245.678Z",
    fill: "url(#paint49_linear_5_2)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M198.97 245.885C198.97 252.465 197.256 258.511 194.386 263.252C190.618 269.495 184.859 273.488 178.407 273.488C174.446 273.488 170.745 271.983 167.607 269.374C161.748 264.513 157.845 255.813 157.845 245.885C157.845 230.641 167.051 218.282 178.407 218.282C189.763 218.282 198.97 230.641 198.97 245.885Z",
    fill: "url(#paint50_linear_5_2)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M194.386 263.252C190.618 269.495 184.859 273.488 178.407 273.488C174.446 273.488 170.745 271.983 167.607 269.374C163.509 265.193 159.941 258.992 159.625 249.968C159.625 249.968 168.048 245.142 172.943 251.672C176.427 256.325 188.58 258.715 194.386 263.252Z",
    fill: "url(#paint51_linear_5_2)"
  }), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M129.681 320.662C125.747 314.747 128.147 305.517 128.651 303.568C130.617 295.975 135.271 291.277 136.966 289.605C148.606 278.131 166.377 278.238 179.837 278.319C193.269 278.4 200.778 278.442 208.968 283.09C223.739 291.47 233.899 310.955 227.975 320.517C224.288 326.471 217.128 324.117 174.604 325.599C147.034 326.563 134.613 328.089 129.681 320.662Z",
    fill: "url(#paint52_linear_5_2)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M172.768 255.54C172.768 255.54 175.607 275.909 161.23 279.945C160.853 280.051 160.51 280.256 160.238 280.539C159.966 280.821 159.774 281.171 159.681 281.552C159.588 281.934 159.598 282.333 159.711 282.709C159.823 283.085 160.033 283.424 160.319 283.692L178.046 300.363C178.301 300.603 178.601 300.789 178.929 300.912C179.257 301.034 179.606 301.09 179.956 301.076C180.306 301.062 180.649 300.978 180.966 300.83C181.283 300.681 181.567 300.471 181.802 300.211L197.892 282.427C198.135 282.158 198.309 281.833 198.398 281.481C198.486 281.129 198.487 280.761 198.4 280.408C198.313 280.056 198.14 279.73 197.898 279.46C197.655 279.19 197.35 278.984 197.009 278.86C191.847 276.958 182.605 271.432 184.543 256.526L172.768 255.54Z",
    fill: "url(#paint53_linear_5_2)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M163.956 244.235C163.956 244.458 167.833 264.331 177.779 264.331C187.201 264.331 190.781 249.696 191.946 242.862C192.07 241.699 192.193 240.537 192.315 239.375C190.978 239.816 189.541 239.859 188.18 239.498C187.749 239.381 185.014 238.637 184.001 236.384C182.87 233.87 184.95 231.872 183.765 229.675C183.078 228.401 181.694 227.805 180.638 227.5C181.341 228.532 182.706 230.834 181.934 232.927C181.416 234.333 179.967 235.679 176.728 236.494C167.475 238.841 163.865 239.733 163.956 244.235Z",
    fill: "url(#paint54_linear_5_2)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M166.388 246.611C166.388 246.611 161.262 242.274 160.816 244.929C159.884 250.463 164.267 253.517 166.647 251.863C169.027 250.209 166.388 246.611 166.388 246.611Z",
    fill: "url(#paint55_linear_5_2)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M188.985 246.611C188.985 246.611 194.111 242.274 194.557 244.929C195.489 250.463 191.106 253.517 188.726 251.863C186.346 250.209 188.985 246.611 188.985 246.611Z",
    fill: "url(#paint56_linear_5_2)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M219.219 288.545C219.219 288.545 219.775 283.269 211.229 271.805C202.683 260.34 206.099 248.561 204.39 240.773C203.514 236.794 203.811 228.281 200.949 220.918C198.941 215.752 194.745 211.674 189.436 209.726C186.807 208.762 184.005 208.354 181.21 208.529C178.414 208.704 175.685 209.457 173.196 210.742C164.742 215.14 151.895 225.456 153.199 247.25C153.23 247.865 153.279 248.48 153.337 249.114C153.337 249.114 152.599 269.688 141.367 279.759C130.135 289.83 138.68 302.914 150.65 308.381C151.207 308.631 151.778 308.847 152.362 309.027C167.333 313.78 220.789 312.395 219.219 288.545ZM179.503 272.005C168.997 272.005 160.48 260.445 160.48 246.187C160.48 231.93 168.997 220.369 179.503 220.369C190.008 220.369 198.523 231.93 198.523 246.187C198.523 260.445 190.008 272.005 179.503 272.005Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1,
    d: "M183.249 301.078C174.225 301.091 146.621 302.52 152.363 309.029C151.78 308.849 151.208 308.634 150.651 308.384C138.682 302.917 130.133 289.831 141.368 279.762C152.604 269.692 153.338 249.117 153.338 249.117C153.28 248.484 153.231 247.866 153.2 247.252C153.424 247.289 153.635 247.381 153.815 247.519C155.652 248.89 155.443 253.952 155.617 255.902C156.009 260.172 156.347 264.481 157.597 268.605C157.929 269.72 158.317 270.818 158.758 271.894C160.591 276.368 163.354 280.362 167.485 283.086C172.678 286.51 179.152 288.059 185.329 288.184C207.125 288.625 192.887 301.064 183.249 301.078Z",
    fill: "url(#paint57_linear_5_2)"
  }), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6955 351.927C67.5806 349.765 68.1301 346.56 69.2302 340.15C69.7734 336.983 72.2649 322.464 78.5925 313.385C90.6 296.157 117.888 296.403 133.141 296.537C151.27 296.7 169.856 296.869 182.921 310.971C193.924 322.849 200.351 343.904 192.271 353.782C184.494 363.293 170.465 353.701 130.22 354.069C96.404 354.379 73.6071 361.455 68.6955 351.927Z",
    fill: "url(#paint58_linear_5_2)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M130.756 289.028C115.837 288.994 99.7731 295.801 100.098 300.943C100.438 306.331 118.763 309.808 131.825 309.905C143.98 309.996 162.045 307.24 162.554 301.947C163.044 296.733 146.514 289.064 130.756 289.028Z",
    fill: "url(#paint59_linear_5_2)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M122.982 274.039C122.982 274.039 126.857 299.421 112.657 301.601L133.406 306.241L150.754 301.398C150.754 301.398 137.672 297.861 139.552 276.983L122.982 274.039Z",
    fill: "url(#paint60_linear_5_2)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M145.828 267.693C145.828 276.415 139.166 283.487 130.947 283.487C122.727 283.487 116.064 276.415 116.064 267.693C116.064 258.971 122.726 242.154 130.947 242.154C139.167 242.154 145.828 258.971 145.828 267.693Z",
    fill: "url(#paint61_linear_5_2)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M144.822 264.739C144.822 264.739 148.348 262.096 150.165 264.862C152.716 268.742 144.47 272.71 144.47 272.71L144.822 264.739Z",
    fill: "url(#paint62_linear_5_2)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M117.014 264.739C117.014 264.739 113.488 262.096 111.67 264.862C109.121 268.742 117.366 272.71 117.366 272.71L117.014 264.739Z",
    fill: "url(#paint63_linear_5_2)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M116.877 270.403C116.177 270.566 111.334 261.123 113.01 251.862C116.09 234.835 138.121 227.473 139.581 229.926C140.33 231.186 136.161 235.875 137.178 237.272C138.141 238.594 142.532 235.32 143.363 236.617C144.12 237.798 141.028 241.39 141.8 242.6C142.572 243.81 146.225 240.853 147.423 242.21C149.119 244.137 143.725 252.334 145.948 255.369C146.702 256.401 147.587 255.815 148.438 256.905C150.817 259.945 147.431 268.989 145.948 268.75C144.819 268.568 145.867 263.165 142.719 257.782C141.543 255.773 139.936 254.051 138.013 252.74C135.593 253.584 133.337 254.838 131.341 256.446C129.462 257.973 129.672 258.683 128.326 259.43C124.787 261.398 121.514 258.478 119.284 260.422C118.574 261.037 118.301 262.182 117.758 264.461C116.867 268.178 117.199 270.326 116.877 270.403Z",
    fill: "url(#paint64_linear_5_2)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M136.783 249.203C133.576 247.887 133.331 243.816 129.987 242.919C123.552 241.198 117.011 254.278 115.189 252.972C114.508 252.48 114.566 250.046 116.968 242.592C115.077 245.273 113.649 248.363 113.01 251.862C111.334 261.123 116.177 270.566 116.877 270.403C117.199 270.326 116.867 268.178 117.757 264.461C118.301 262.182 118.573 261.042 119.283 260.422C121.513 258.478 124.786 261.392 128.325 259.43C129.677 258.683 129.461 257.973 131.34 256.446C133.335 254.838 135.592 253.584 138.012 252.74C139.935 254.051 141.542 255.773 142.718 257.782C145.866 263.165 144.817 268.568 145.947 268.75C147.429 268.989 150.816 259.945 148.437 256.905C147.585 255.815 146.7 256.401 145.947 255.369C144.251 253.052 146.989 247.732 147.63 244.484C142.284 249.649 138.947 250.092 136.783 249.203Z",
    fill: "url(#paint65_linear_5_2)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M218.082 270.154C218.082 270.154 217.202 266.08 214.193 268.621C211.184 271.161 215.969 277.903 219.917 277.625L218.082 270.154Z",
    fill: "url(#paint66_linear_5_2)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M246.895 267.555C246.39 267.897 244.94 277.462 244.94 277.462C244.94 277.462 247.476 277.761 249.313 274.327C251.149 270.893 252.032 264.08 246.895 267.555Z",
    fill: "url(#paint67_linear_5_2)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M235.698 354.028C192.987 354.357 178.015 359.987 171.232 350.724C164.99 342.199 170.161 327.19 177.611 318.597C189.387 305.014 208.292 304.347 234.151 303.625C258.474 302.948 273.461 302.53 285.296 313.018C296.358 322.822 303.425 341.058 296.535 350.478C290.145 359.22 276.476 353.713 235.698 354.028Z",
    fill: "url(#paint68_linear_5_2)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M219.884 303.582L214.883 304.864C214.598 304.936 214.335 305.075 214.114 305.269C213.893 305.463 213.722 305.707 213.614 305.981C213.506 306.254 213.464 306.549 213.493 306.842C213.521 307.135 213.619 307.417 213.777 307.664C217.182 312.976 226.199 326.312 231.846 327.88C237.683 329.502 248.589 312.603 252.217 306.657C252.364 306.417 252.454 306.146 252.48 305.866C252.507 305.586 252.47 305.304 252.371 305.04C252.273 304.777 252.116 304.539 251.912 304.345C251.709 304.151 251.464 304.006 251.196 303.92L247.528 302.752C244.528 301.797 241.369 301.436 238.231 301.691L224.559 302.798C222.981 302.927 221.417 303.189 219.884 303.582Z",
    fill: "url(#paint69_linear_5_2)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M223.596 284.155C223.596 284.155 226.343 303.936 222.543 305.826L233.36 317.621L244.319 303.646C244.319 303.646 240.177 300.525 241.268 284.152L223.596 284.155Z",
    fill: "url(#paint70_linear_5_2)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M217.214 255.841C216.823 256.37 212.938 289.902 230.507 292.51C248.076 295.119 247.66 268.089 247.436 260.274C247.212 252.458 239.175 249.62 234.575 249.074C229.976 248.527 218.6 253.961 217.214 255.841Z",
    fill: "url(#paint71_linear_5_2)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M217.667 265.398C218.126 262.019 218.651 258.12 221.355 256.396C225.288 253.893 230.297 258.199 233.892 255.412C235.269 254.345 235.822 252.719 236.074 251.477C236.874 251.753 243.235 254.067 245.576 260.862C246.5 263.59 246.622 266.527 245.927 269.323C246.078 269.244 246.23 269.165 246.38 269.084C246.846 268.838 247.307 268.571 247.767 268.311C247.982 267.553 248.258 266.658 248.627 265.698C249.9 262.299 251.223 261.757 252.66 258.244C253.813 255.427 255.301 251.788 253.794 249.286C251.943 246.212 247.268 247.669 245.903 244.706C244.756 242.217 247.452 239.876 246.005 237.725C244.796 235.925 241.84 235.97 241.315 235.978C237.32 236.039 236.406 239.203 233.558 239.132C230.08 239.044 229.944 234.287 225.346 232.284C220.883 230.341 214.362 231.923 211.726 235.567C209.677 238.396 211.42 240.487 208.733 244.122C206.889 246.625 205.252 246.736 204.334 249.185C203.473 251.485 204.055 253.677 204.511 255.304C205.605 259.206 207.643 260.928 210.723 265.08C211.314 265.878 212 266.841 212.743 267.966C214.317 268.581 215.9 269.173 217.513 269.672C217.422 268.246 217.474 266.814 217.667 265.398Z",
    fill: "url(#paint72_linear_5_2)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_2",
    x1: 117.109,
    y1: 96.5482,
    x2: 273.093,
    y2: 96.5482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5_2",
    x1: 120.773,
    y1: 77.4981,
    x2: 272.874,
    y2: 77.4981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5_2",
    x1: 117.108,
    y1: 73.1014,
    x2: 273.115,
    y2: 73.1014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5_2",
    x1: 127.204,
    y1: 107.836,
    x2: 280.174,
    y2: 107.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5_2",
    x1: 128.766,
    y1: 142.029,
    x2: 280.06,
    y2: 142.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5_2",
    x1: 127.207,
    y1: 185.288,
    x2: 280.202,
    y2: 185.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5_2",
    x1: 292.989,
    y1: 142.267,
    x2: 329.906,
    y2: 142.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5_2",
    x1: 256.219,
    y1: 106.98,
    x2: 303.783,
    y2: 106.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#6D2F66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5_2",
    x1: 299.552,
    y1: 47.752,
    x2: 260.124,
    y2: 180.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BD6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39C8DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_5_2",
    x1: 111.623,
    y1: 183.495,
    x2: 159.187,
    y2: 183.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#6D2F66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_5_2",
    x1: 154.957,
    y1: 124.267,
    x2: 115.529,
    y2: 257.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_5_2",
    x1: 85.7977,
    y1: 73.704,
    x2: 133.362,
    y2: 73.704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#6D2F66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_5_2",
    x1: 129.131,
    y1: 14.4764,
    x2: 89.7036,
    y2: 147.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BD6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FD0E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_5_2",
    x1: 276.397,
    y1: 265.15,
    x2: 275.504,
    y2: 400.873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54DDEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4BD6E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_5_2",
    x1: 379.261,
    y1: 247.624,
    x2: 275.187,
    y2: 291.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39C8DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4BD6E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_5_2",
    x1: 77.0647,
    y1: 264.795,
    x2: 76.175,
    y2: 399.932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BD6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9571F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_5_2",
    x1: 138.75,
    y1: 253.91,
    x2: 7.00761,
    y2: 234.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39C8DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_5_2",
    x1: 222.563,
    y1: 156.863,
    x2: 216.122,
    y2: 164.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_5_2",
    x1: 222.36,
    y1: 156.702,
    x2: 215.92,
    y2: 164.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_5_2",
    x1: 227.285,
    y1: 171.059,
    x2: 209.378,
    y2: 218.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_5_2",
    x1: 232.669,
    y1: 173.089,
    x2: 214.761,
    y2: 220.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_5_2",
    x1: 226.995,
    y1: 171.692,
    x2: 209.297,
    y2: 218.611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_5_2",
    x1: 212.585,
    y1: 289.625,
    x2: 219.793,
    y2: 207.107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E38DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#AC79EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9571F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_5_2",
    x1: 215.289,
    y1: 275.014,
    x2: 212.013,
    y2: 204.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_5_2",
    x1: 243.215,
    y1: 177.068,
    x2: 225.306,
    y2: 224.541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_5_2",
    x1: 243.215,
    y1: 177.068,
    x2: 225.306,
    y2: 224.541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_5_2",
    x1: 212.348,
    y1: 221.518,
    x2: 216.683,
    y2: 115.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_5_2",
    x1: 144.064,
    y1: 214.995,
    x2: 134.352,
    y2: 137.876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B3976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_5_2",
    x1: 142.36,
    y1: 215.21,
    x2: 132.648,
    y2: 138.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B3976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_5_2",
    x1: 139.688,
    y1: 232.451,
    x2: 142.691,
    y2: 328.735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_5_2",
    x1: 141.553,
    y1: 243.084,
    x2: 143.191,
    y2: 193.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_5_2",
    x1: 138.559,
    y1: 201.339,
    x2: 140.687,
    y2: 168.758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_5_2",
    x1: 153.876,
    y1: 202.341,
    x2: 156.006,
    y2: 169.759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_5_2",
    x1: 123.849,
    y1: 200.378,
    x2: 125.98,
    y2: 167.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_5_2",
    x1: 139.075,
    y1: 189.299,
    x2: 140.55,
    y2: 129.369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_5_2",
    x1: 259.818,
    y1: 361.266,
    x2: 255.71,
    y2: 305.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BD6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39C8DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_5_2",
    x1: 251.931,
    y1: 269.815,
    x2: 251.439,
    y2: 239.852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_5_2",
    x1: 252.163,
    y1: 272.915,
    x2: 252,
    y2: 246.707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_5_2",
    x1: 249.991,
    y1: 235.413,
    x2: 254.251,
    y2: 184.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_5_2",
    x1: 234.836,
    y1: 234.153,
    x2: 239.095,
    y2: 182.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_5_2",
    x1: 267.224,
    y1: 236.845,
    x2: 271.483,
    y2: 185.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_5_2",
    x1: 248.867,
    y1: 210.704,
    x2: 260.169,
    y2: 175.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B3976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_5_2",
    x1: 248.868,
    y1: 210.705,
    x2: 260.17,
    y2: 175.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B3976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_5_2",
    x1: 144.608,
    y1: 212.267,
    x2: 72.4989,
    y2: 354.129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BD6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2F4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_5_2",
    x1: 96.1004,
    y1: 290.271,
    x2: 96.5889,
    y2: 252.977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_5_2",
    x1: 92.6797,
    y1: 248.5,
    x2: 96.7207,
    y2: 211.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_5_2",
    x1: 77.6702,
    y1: 247.396,
    x2: 77.4988,
    y2: 210.283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_5_2",
    x1: 109.546,
    y1: 250.378,
    x2: 113.587,
    y2: 213.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_5_2",
    x1: 66.8259,
    y1: 227.938,
    x2: 117.367,
    y2: 227.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_5_2",
    x1: 98.5058,
    y1: 213.665,
    x2: 95.229,
    y2: 241.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_5_2",
    x1: 157.841,
    y1: 245.885,
    x2: 198.97,
    y2: 245.885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40447E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C3B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_5_2",
    x1: 159.621,
    y1: 260.869,
    x2: 194.386,
    y2: 260.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40447E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C3B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_5_2",
    x1: 183.886,
    y1: 351.55,
    x2: 174.413,
    y2: 282.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_5_2",
    x1: 180.04,
    y1: 303.184,
    x2: 177.856,
    y2: 255.813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_5_2",
    x1: 177.618,
    y1: 261.522,
    x2: 178.456,
    y2: 229.474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_5_2",
    x1: 163.902,
    y1: 258.188,
    x2: 164.666,
    y2: 228.936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_5_2",
    x1: 190.93,
    y1: 258.895,
    x2: 191.694,
    y2: 229.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_5_2",
    x1: 136.121,
    y1: 278.141,
    x2: 196.798,
    y2: 278.141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_5_2",
    x1: 119.244,
    y1: 302.511,
    x2: 161.377,
    y2: 437.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_5_2",
    x1: 100.093,
    y1: 299.467,
    x2: 162.559,
    y2: 299.467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_5_2",
    x1: 131.629,
    y1: 303.076,
    x2: 134.128,
    y2: 253.468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_5_2",
    x1: 127.842,
    y1: 282.088,
    x2: 147.618,
    y2: 188.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_5_2",
    x1: 143.587,
    y1: 285.411,
    x2: 163.364,
    y2: 191.707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_5_2",
    x1: 112.289,
    y1: 278.806,
    x2: 132.067,
    y2: 185.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_5_2",
    x1: 112.659,
    y1: 249.936,
    x2: 149.261,
    y2: 249.936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_5_2",
    x1: 112.659,
    y1: 256.498,
    x2: 149.261,
    y2: 256.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_5_2",
    x1: 216.627,
    y1: 281.399,
    x2: 216.456,
    y2: 244.287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_5_2",
    x1: 246.619,
    y1: 284.634,
    x2: 250.66,
    y2: 247.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_5_2",
    x1: 277.823,
    y1: 253.244,
    x2: 215.586,
    y2: 375.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BD6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2F4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_5_2",
    x1: 232.125,
    y1: 353.493,
    x2: 233.354,
    y2: 286.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#6F2B60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A03976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_5_2",
    x1: 233.172,
    y1: 324.526,
    x2: 233.66,
    y2: 287.234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_5_2",
    x1: 229.178,
    y1: 290.874,
    x2: 234.185,
    y2: 245.161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_5_2",
    x1: 203.899,
    y1: 250.557,
    x2: 254.44,
    y2: 250.557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 354,
    height: 358,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroTwo);
export default __webpack_public_path__ + "static/media/introTwo.195921700cc3031dfe0f4ed2de738e93.svg";
export { ForwardRef as ReactComponent };